import { render, staticRenderFns } from "./_view.vue?vue&type=template&id=0537b1ef&scoped=true"
import script from "./_view.vue?vue&type=script&lang=js"
export * from "./_view.vue?vue&type=script&lang=js"
import style0 from "./_view.vue?vue&type=style&index=0&id=0537b1ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0537b1ef",
  null
  
)

export default component.exports